// @ts-nocheck
import { useRef } from 'react';
import styled from 'styled-components';
import type { Swiper as SwiperInstance } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface IMedia {
  id: string;
  url: string;
  type: 'image' | 'video';
}

interface IGalleryProps {
  photos: IMedia[];
  initialIndex?: number;
}

const Carousel: React.FC<IGalleryProps> = ({ photos, initialIndex = 0 }) => {
  const videoRefs = useRef<Record<string, HTMLVideoElement | null>>({});

  const handleSlideChange = (swiper: SwiperInstance) => {
    const currentSlide = photos[swiper.activeIndex];

    if (currentSlide.type === 'video') {
      const video = videoRefs.current[currentSlide.id];
      if (video) {
        video.load();
      }
    }
  };


  return (
    <StyledSwiper
      modules={[Navigation, Pagination]}
      navigation
      pagination={{ clickable: true }}
      spaceBetween={10}
      slidesPerView={1}
      initialSlide={initialIndex}
      onSlideChange={handleSlideChange}
    >
      {photos.map((media) => (
        <SwiperSlideStyled key={media.id}>
          <MediaWrapper>
            {media.type === 'image' ? (
              <StyledImage src={media.url} alt="Character photo" />
            ) : (
              <FullscreenVideo
                ref={(el) => (videoRefs.current[media.id] = el)}
                src={media.url}
                autoPlay
                loop
                onClick={(e) => e.stopPropagation()}
              />
            )}
          </MediaWrapper>
        </SwiperSlideStyled>
      ))}
    </StyledSwiper>
  );
};

export default Carousel;


const StyledSwiper = styled(Swiper)`
  width: 100%;
  max-width: 600px;

  .swiper-button-prev,
  .swiper-button-next {
    color: white;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 24px;
    user-select: none;
  }
`;

const FullscreenVideo = styled.video`
  min-height: 60vh;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
    min-height: 80vh;
  }
`;

const SwiperSlideStyled = styled(SwiperSlide)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
    min-height: 80vh;
  }
`;

const MediaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 80vh;
  overflow: hidden;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
  border-radius: 12px;
  display: block;
  margin: auto;
  user-select: none;
`;
